import styled from 'styled-components'

export const StyledDiv = styled.div({
  marginBottom: '24px'
})
